import { last, set } from 'lodash';
import { isFormula } from '../utils/tableFormulaUtils';
import { reorderCellSelection } from '../utils/tableCellSelectionUtils';
import { createTableCellEntry, getDisplayValueOfCellContentString } from '../utils/tableInitialisationUtils';
import { getColumnCount, getRowCount } from '../utils/tableDataUtils';

let copySource;
let autofillSource;

const getSourceCellDataArray = (hotTableInstanceRef, cellSelection) => {
    const [fromRow, fromCol, toRow, toCol] = reorderCellSelection(cellSelection);

    const sourceCellDataArray = [];
    for (let row = fromRow; row <= toRow; row++) {
        sourceCellDataArray.push([]);
        for (let col = fromCol; col <= toCol; col++) {
            const { cellData = createTableCellEntry() } = hotTableInstanceRef.current.getCellMeta(row, col);
            const displayValue = hotTableInstanceRef.current.getCopyableData(row, col);

            last(sourceCellDataArray).push({ displayValue, cellData });
        }
    }

    return sourceCellDataArray;
};

const setTableCopySource = (hotTableInstanceRef, cellSelection) => {
    copySource = getSourceCellDataArray(hotTableInstanceRef, cellSelection);
};

const setTableAutofillSource = (hotTableInstanceRef, cellSelection) => {
    autofillSource = getSourceCellDataArray(hotTableInstanceRef, cellSelection);
};

const getTableCopiedDataForValues = (values) => {
    if (!copySource) return;

    const nRowsOfValues = getRowCount(values);
    const nColsOfValues = getColumnCount(values);
    const nRowsOfCopySource = getRowCount(copySource);
    const nColsOfCopySource = getColumnCount(copySource);

    // Check first if the source data matches the changes. This should match if data is copied from Milanote table,
    // but will not match if copying from external application (e.g. Apple Numbers).
    const isValidCopy =
        nRowsOfCopySource === nRowsOfValues &&
        nColsOfCopySource === nColsOfValues &&
        copySource.every((rowData, row) =>
            rowData.every(
                ({ displayValue }, col) => displayValue === getDisplayValueOfCellContentString(values[row][col]),
            ),
        );

    if (!isValidCopy) return;

    return copySource.map((rowData, row) =>
        rowData.map(({ displayValue, cellData }) => {
            if (isFormula(cellData.value)) return { ...cellData, value: displayValue };

            return cellData;
        }),
    );
};

const getTableCopiedDataForChanges = (changes) => {
    const minChangeRow = Math.min(...changes.map(([row]) => row));
    const minChangeCol = Math.min(...changes.map(([, col]) => col));

    const values = [];

    changes.forEach(([row, col, , value]) => set(values, [row - minChangeRow, col - minChangeCol], value));

    return getTableCopiedDataForValues(values);
};

const getTableAutofillData = () => {
    return autofillSource.map((rowData) => rowData.map(({ cellData }) => cellData));
};

const HotTableClipboardManager = {
    setTableCopySource,
    getTableCopiedDataForValues,
    getTableCopiedDataForChanges,
    getTableAutofillData,
    setTableAutofillSource,
};

export default HotTableClipboardManager;
